import { useMemo } from 'react';

import type { TakeoverMatch } from 'bundles/search-common/experiments/takeoverPilot/getTakeoverMatchForQuery';
import { isTakeoverMatch } from 'bundles/search-common/experiments/takeoverPilot/isTakeoverMatch';
import type { SearchHit, SearchUpsellHit } from 'bundles/search-common/providers/searchTypes';

export type TakeoverPilotMatchedHit = { hit: SearchHit; campaign: TakeoverMatch } | undefined;

export const useTakeoverPilotMatchedHit = (
  hits: Array<SearchHit | SearchUpsellHit> | undefined,
  takeoverMatch: TakeoverMatch | null | undefined
): TakeoverPilotMatchedHit => {
  return useMemo(() => {
    if (!takeoverMatch) {
      return undefined;
    }
    const hit = hits?.find((candidate) => isTakeoverMatch(candidate, takeoverMatch));
    return hit ? { hit: hit as SearchHit, campaign: takeoverMatch } : undefined;
  }, [hits, takeoverMatch]);
};

export default useTakeoverPilotMatchedHit;
